var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrincessStorePin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 54,
    viewBox: "0 0 44 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3017_974)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3017_974",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 54
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 0H0V54H44V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3017_974)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9683 7.40846C32.8863 3.19851 27.5699 0.878906 22.0001 0.878906C16.4251 0.878906 11.1087 3.19851 7.02407 7.41113C2.8781 11.6877 0.601158 17.4334 0.779794 23.1765C1.28371 39.451 20.4537 52.1235 21.2723 52.6541L21.9895 53.1207L22.7147 52.6621C23.5305 52.1449 42.714 39.779 43.2205 23.1738C43.3965 17.4334 41.1169 11.6851 36.9683 7.40846Z",
    fill: "#0E0E0E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3017_974",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 14,
    width: 33,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8831 14H6V34H38.8831V14Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3017_974)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3017_974",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 14,
    width: 32,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 14.2686H6V33.7314H38V14.2686Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3017_974)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3017_974",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 14,
    width: 32,
    height: 20
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38 14.2661H6V33.734H38V14.2661Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3017_974)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7813 19.1213C36.2552 19.1213 35.8247 19.5518 35.8247 20.078C35.8247 20.6041 36.2552 21.0346 36.7813 21.0346C37.3075 21.0346 37.738 20.6041 37.738 20.078C37.7619 19.5518 37.3314 19.1213 36.7813 19.1213Z",
    fill: "#F2E3B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.817 18.2124C28.2909 18.2124 27.8604 18.6429 27.8604 19.169C27.8604 19.6953 28.2909 20.1257 28.817 20.1257C29.3432 20.1257 29.7737 19.6953 29.7737 19.169C29.7976 18.6668 29.3432 18.2124 28.817 18.2124Z",
    fill: "#F2E3B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2337 27.5639L28.2188 23.7613L28.9601 27.0138L29.8929 26.0811L28.8166 21.4175C28.7449 21.1304 28.3623 21.0826 28.2188 21.3457L25.7793 26.0573L26.2337 27.5639Z",
    fill: "#F2E3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1841 20.1501C15.7104 20.1501 16.1408 19.7196 16.1408 19.1935C16.1408 18.6673 15.7104 18.2368 15.1841 18.2368C14.658 18.2368 14.2275 18.6673 14.2275 19.1935C14.2036 19.7196 14.6341 20.1501 15.1841 20.1501Z",
    fill: "#F2E3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.782 23.7613L17.7671 27.5639L18.2215 26.0573L15.7581 21.3457C15.6146 21.0826 15.232 21.1304 15.1602 21.4175L14.084 26.0811L15.0167 27.0138L15.782 23.7613Z",
    fill: "#F2E3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9996 16.4426C22.5258 16.4426 22.9563 16.0121 22.9563 15.486C22.9563 14.9598 22.5258 14.5293 21.9996 14.5293C21.4735 14.5293 21.043 14.9598 21.043 15.486C21.043 16.0121 21.4735 16.4426 21.9996 16.4426Z",
    fill: "#F2E3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1964 19.1213C6.67024 19.1213 6.23975 19.5518 6.23975 20.078C6.23975 20.6041 6.67024 21.0346 7.1964 21.0346C7.72256 21.0346 8.15306 20.6041 8.15306 20.078C8.17697 19.5518 7.74648 19.1213 7.1964 19.1213Z",
    fill: "#F2E3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3051 31.3191L22.311 18.0454C22.2153 17.7345 21.7849 17.7345 21.7131 18.0454L17.6952 31.3191L9.08529 22.3982C8.84613 22.159 8.43955 22.3982 8.55914 22.733L12.601 33.7585L13.0793 31.893L10.9508 25.9857L18.1974 33.5193L22.0001 20.9393L25.8028 33.5193L33.0495 25.9857L30.897 31.7735L31.3992 33.7346L35.4411 22.7091C35.5606 22.3982 35.1541 22.1352 34.9149 22.3743L26.3051 31.3191Z",
    fill: "#F2E3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7813 19.1213C36.2552 19.1213 35.8247 19.5518 35.8247 20.078C35.8247 20.6041 36.2552 21.0346 36.7813 21.0346C37.3075 21.0346 37.738 20.6041 37.738 20.078C37.7619 19.5518 37.3314 19.1213 36.7813 19.1213Z",
    fill: "url(#paint0_linear_3017_974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.817 18.2124C28.2909 18.2124 27.8604 18.6429 27.8604 19.169C27.8604 19.6953 28.2909 20.1257 28.817 20.1257C29.3432 20.1257 29.7737 19.6953 29.7737 19.169C29.7976 18.6668 29.3432 18.2124 28.817 18.2124Z",
    fill: "url(#paint1_linear_3017_974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2337 27.5639L28.2188 23.7613L28.9601 27.0138L29.8929 26.0811L28.8166 21.4175C28.7449 21.1304 28.3623 21.0826 28.2188 21.3457L25.7793 26.0573L26.2337 27.5639Z",
    fill: "url(#paint2_linear_3017_974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1841 20.1501C15.7104 20.1501 16.1408 19.7196 16.1408 19.1935C16.1408 18.6673 15.7104 18.2368 15.1841 18.2368C14.658 18.2368 14.2275 18.6673 14.2275 19.1935C14.2036 19.7196 14.6341 20.1501 15.1841 20.1501Z",
    fill: "url(#paint3_linear_3017_974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.782 23.7613L17.7671 27.5639L18.2215 26.0573L15.7581 21.3457C15.6146 21.0826 15.232 21.1304 15.1602 21.4175L14.084 26.0811L15.0167 27.0138L15.782 23.7613Z",
    fill: "url(#paint4_linear_3017_974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9996 16.4426C22.5258 16.4426 22.9563 16.0121 22.9563 15.486C22.9563 14.9598 22.5258 14.5293 21.9996 14.5293C21.4735 14.5293 21.043 14.9598 21.043 15.486C21.043 16.0121 21.4735 16.4426 21.9996 16.4426Z",
    fill: "url(#paint5_linear_3017_974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1964 19.1213C6.67024 19.1213 6.23975 19.5518 6.23975 20.078C6.23975 20.6041 6.67024 21.0346 7.1964 21.0346C7.72256 21.0346 8.15306 20.6041 8.15306 20.078C8.17697 19.5518 7.74648 19.1213 7.1964 19.1213Z",
    fill: "url(#paint6_linear_3017_974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3051 31.3191L22.311 18.0454C22.2153 17.7345 21.7849 17.7345 21.7131 18.0454L17.6952 31.3191L9.08529 22.3982C8.84613 22.159 8.43955 22.3982 8.55914 22.733L12.601 33.7585L13.0793 31.893L10.9508 25.9857L18.1974 33.5193L22.0001 20.9393L25.8028 33.5193L33.0495 25.9857L30.897 31.7735L31.3992 33.7346L35.4411 22.7091C35.5606 22.3982 35.1541 22.1352 34.9149 22.3743L26.3051 31.3191Z",
    fill: "url(#paint7_linear_3017_974)"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3017_974",
    x1: 6.24024,
    y1: 24.1233,
    x2: 37.7552,
    y2: 24.1233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2DC94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2877,
    stopColor: "#E3D39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3017_974",
    x1: 6.24,
    y1: 24.1231,
    x2: 37.7551,
    y2: 24.1231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2DC94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2877,
    stopColor: "#E3D39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3017_974",
    x1: 6.23965,
    y1: 24.1234,
    x2: 37.7547,
    y2: 24.1234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2DC94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2877,
    stopColor: "#E3D39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3017_974",
    x1: 6.23947,
    y1: 24.1237,
    x2: 37.7545,
    y2: 24.1237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2DC94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2877,
    stopColor: "#E3D39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3017_974",
    x1: 6.23943,
    y1: 24.1234,
    x2: 37.7545,
    y2: 24.1234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2DC94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2877,
    stopColor: "#E3D39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3017_974",
    x1: 6.2388,
    y1: 24.1232,
    x2: 37.7538,
    y2: 24.1232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2DC94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2877,
    stopColor: "#E3D39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3017_974",
    x1: 6.23975,
    y1: 24.1233,
    x2: 37.7548,
    y2: 24.1233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2DC94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2877,
    stopColor: "#E3D39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3017_974",
    x1: 6.23925,
    y1: 24.1236,
    x2: 37.7543,
    y2: 24.1236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2DC94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2877,
    stopColor: "#E3D39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA145"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3017_974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrincessStorePin);
export default __webpack_public_path__ + "static/media/PrincessStorePin.89c3a7fae28ba7234fe8ccc8789e606e.svg";
export { ForwardRef as ReactComponent };